import { gql, useQuery } from "@apollo/client";
import { faFilePdf } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useApplicationContext } from "components/Application";
import { CenterSpinner } from "components/CenterSpinner";
import { Footer } from "components/Footer";
import moment from "moment";
import React from "react";
import { useTranslation } from "react-i18next";

import "twin.macro";

const orderDocumentsQuery = gql`
  query OrderDocuments {
    accountSession {
      currentUser {
        documents {
          id
          code
          status
          notes
          document
          seasonKind
          insertedAt
          quantity
          grandTotal
        }
      }
    }
  }
`;

export const List: React.FC<{}> = () => {
  const { loading, data } = useQuery(orderDocumentsQuery);
  const { i18n } = useTranslation();
  const {
    siteEnvironment: { appEndpointStore },
  } = useApplicationContext();

  if (loading) return <CenterSpinner size="large" />;

  const userDocuments = data.accountSession.currentUser.documents;

  return (
    <div tw="flex space-x-2">
      <div tw="flex flex-col space-x-2 w-full">
        <div>
          <div tw="flex w-full justify-between px-6">
            <div tw="text-gray-500">{i18n.language === "it" ? "I TUOI ORDINI" : "YOUR ORDERS"}</div>
          </div>
        </div>
        <div tw="flex px-16 flex-col space-x-0 space-y-12 w-full mx-4" style={{ margin: "4rem auto" }}>
          {userDocuments.length > 0 && (
            <div tw="w-full">
              <p tw="font-bold text-2xl">
                {i18n.language === "it" ? "STORICO ORDINI SHOWROOM" : "ORDER HISTORY SHOWROOM"}
              </p>
              {userDocuments.map((order: any, index: number) => (
                <div key={index} tw="flex-col border-b-2 mb-4">
                  <div tw="flex space-x-8 justify-between">
                    <div>
                      {order.seasonKind === "current" ? (
                        <p tw="font-bold ">
                          {i18n.language === "it" ? "ORDINE STAGIONALE DEL" : "SEASONAL ORDER"}{" "}
                          {moment(order.insertedAt).format("DD-MM-YYYY")}
                        </p>
                      ) : (
                        <p tw="font-bold ">
                          {i18n.language === "it" ? "ORDINE MAGAZZINO DEL" : "STOCK ORDER"}{" "}
                          {moment(order.insertedAt).format("DD-MM-YYYY")}
                        </p>
                      )}
                    </div>
                    <div tw="flex space-x-6 justify-between">
                      <p tw="">{i18n.language === "it" ? "Pezzi:" : "Quantity:"}</p>
                      <p tw="font-bold ">{order.quantity}</p>
                    </div>
                    <div tw="flex space-x-6 justify-between">
                      <p tw="">{i18n.language === "it" ? "Totale:" : "Total:"}</p>
                      <p tw="font-bold ">{order.grandTotal}</p>
                    </div>
                    <div>
                      {order.document && (
                        <>
                          <a
                            tw="mr-2 underline"
                            target="_blank"
                            rel="noreferrer"
                            href={`${appEndpointStore}${order.document}`}
                          >
                            PDF
                          </a>
                          <FontAwesomeIcon tw="text-gray-900" icon={faFilePdf} />
                        </>
                      )}
                    </div>
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>

        <Footer />
      </div>
    </div>
  );
};
